import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SnackBarService } from "../../service/snack.bar.service";
export interface DialogData {
  title: string;
  content: string;
  showTextBox: boolean;
  no: string;
  yes: string;
}

@Component({
  selector: "update-unit",
  templateUrl: "update-unit.html",
})
export class UpdateUnit {
  file: any;
  fileName: string;
  constructor(
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<UpdateUnit>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    if (data != null) {
    }
  }
  fileChangeEvent(fileInput) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.file = fileInput.target.files[0];
      this.fileName = this.file.name;
    }
  }
  upload() {
    if (!this.fileName) {
      this.snackBarService.show("Please upload the excel file");
      return;
    }
    this.dialogRef.close(this.file);
  }
}
